<template>
	<q-dialog v-model="isVisible" persistent backdrop-filter="blur(4px)" :maximized="isMobileView"
		class="tw-overflow-hidden">
		<q-card v-if="!isSuccess && !isError" style="border-radius: 20px;"
			class="tw-relative tw-px-7 md:tw-px-16 lg:tw-px-24 tw-py-1 md:tw-py-10 tw-flex tw-flex-col tw-gap-6 md:tw-gap-8 tw-w-full md:tw-min-w-[45vw] tw-overflow-hidden">
			<!-- Mobile Close Button -->
			<q-btn flat round dense icon="close" v-close-popup
				class="tw-absolute tw-top-3 tw-right-3 tw-block sm:tw-hidden tw-z-[10]" />
			<!-- Scrollable Content Area for Mobile -->
			<div class="tw-flex-1 tw-overflow-x-hidden md:tw-overflow-visible">
				<!-- Banner -->
				<div v-if="isMobileView"
					class="tw-relative tw-flex tw-flex-row tw-justify-center tw-items-center tw-my-9 tw-h-12 tw-z-10">
					<div class="tw-absolute tw--left-7 tw--right-7 tw-h-full tw-bg-[rgba(31,70,17,0.93)] tw-bg-opacity-80"
						style="width: 100vw; left: calc(-50vw + 50%);"></div>
					<img :src="logo" alt="Quasar logo" class="tw-w-20 tw-z-10" />
				</div>
				<!-- Header Row with Desktop Close -->
				<div class="tw-flex tw-items-center tw-justify-between">
					<p class="tw-text-2xl tw-text-[#f35610] tw-font-SemiExpandedExtraBold">SIGN IN</p>
					<q-btn flat round dense icon="close" v-close-popup class="tw-hidden  sm:tw-block" />
				</div>
				<!-- Info Text -->
				<div class="tw-items-center tw-text-center tw-my-5 md:tw-my-4">
					<p
						class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-[25px] md:tw-text-[30px] tw-leading-7 md:tw-leading-9">
						A verification link will be sent to your registered email address.
					</p>
				</div>
				<!-- Email Input -->
				<div class="tw-flex tw-flex-col tw-gap-1">
					<label class="tw-text-[20px] tw-text-[#666] tw-font-ExpandedRegular">Email Address</label>
					<q-input v-model="email" outlined dense placeholder="Enter your email" :error="!!emailError"
						:error-message="emailError" @blur="validateEmail" @keyup.enter="sendLink" />
				</div>

				<!-- Submit Button -->
				<div class=" tw-bg-white tw-z-10 tw-mt-5">
					<q-btn label="SEND LINK" type="submit" @click="sendLink"
						class="tw-w-full tw-rounded-xl tw-text-white tw-text-xl tw-font-SemiExpandedBoldItalic"
						style="background-color: #f35610; font-style: italic"
						:disable="!email || !!emailError || isLoading" />
				</div>

			</div>
			<div :class="[
				'tw-flex tw-flex-col tw-gap-4',
				isMobileView ? 'tw-mt-auto tw-pt-4 tw-pb-6 tw-bg-white' : 'tw-mt-4'
			]">
				<!-- Divider Section -->
				<div class="tw-flex tw-items-center tw-gap-4 tw-my-0">
					<div class="tw-flex-1 tw-border-t tw-border-[#666666]"></div>

					<span class="tw-text-[#666666] tw-font-ExpandedRegular tw-font-normal tw-text-[22px]">
						Or Login With
					</span>

					<div class="tw-flex-1 tw-border-t tw-border-[#666666]"></div>
				</div>

				<!-- Social Login Icons -->
				<div class="tw-flex tw-justify-center tw-gap-16 md:tw-gap-28">

					<div class="column items-center">
						<q-btn flat round @click="loginTwitter"
							class="tw-p-2 tw-w-16 tw-h-16 md:tw-w-20 md:tw-h-20 lg:tw-w-20 lg:tw-h-20">
							<svg class="tw-w-full tw-h-full" viewBox="0 0 93 93" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<!-- Background Circle -->
								<path
									d="M91.9936 46.5016C91.9936 69.987 74.7726 89.4029 52.4011 92.5536C50.3093 92.8469 48.1691 93 45.9968 93C43.4892 93 41.0268 92.798 38.6288 92.407C16.7279 88.8425 0 69.6449 0 46.5016C0 20.8202 20.5956 0 46 0C71.4044 0 92 20.8202 92 46.5016H91.9936Z"
									fill="#1C1C1B" />
								<!-- Twitter Bird -->
								<g transform="translate(18, 20.5)">
									<path
										d="M0.132435 0L21.3914 28.4311L0 51.5476H4.81573L23.5457 31.3098L38.6776 51.5476H55.0626L32.6086 21.5172L52.5207 0H47.705L30.4575 18.6385L16.5207 0H0.135629H0.132435ZM7.21226 3.54743H14.7378L47.9763 48.0002H40.4508L7.21226 3.54743Z"
										fill="white" />
								</g>
							</svg>
						</q-btn>

						<!-- Label Below -->
						<div class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-base md:tw-text-lg lg:tw-text-xl">
							Twitter/X
						</div>
					</div>

					<div class="column items-center">
						<q-btn flat round @click="loginFacebook"
							class="tw-p-2 tw-w-16 tw-h-16 md:tw-w-20 md:tw-h-20 lg:tw-w-20 lg:tw-h-20">
							<!-- paste combined SVG paths here -->
							<svg class="tw-w-full tw-h-full" viewBox="0 0 93 93" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="46.5" cy="46.5" r="46.5" fill="#1877F2"/>
  <path d="M52.905 48.337H49.592V60.93H44.287V48.337H41.9V43.83H44.287V40.914C44.287 37.843 45.742 35 50.154 35H53.9V39.507H51.23C49.744 39.507 49.592 40.062 49.592 41.102V43.83H53.87L53.317 48.337H52.905Z" fill="white"/>
</svg>
						</q-btn>
						<!-- Label Below -->
						<div class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-base md:tw-text-lg lg:tw-text-xl">
							Facebook
						</div>
					</div>

					<div class="column items-center">
						<q-btn flat round @click="loginApple"
							class="tw-p-2 tw-w-16 tw-h-16 md:tw-w-20 md:tw-h-20 lg:tw-w-20 lg:tw-h-20">
							<!-- paste combined SVG paths here -->
							<svg class="tw-w-full tw-h-full" viewBox="0 0 92 93" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<!-- Background Circle -->
								<path
									d="M91.9936 46.5016C91.9936 69.987 74.7726 89.4029 52.4011 92.5536C50.3093 92.8469 48.1691 93 45.9968 93C43.4892 93 41.0268 92.798 38.6288 92.407C16.7279 88.8425 0 69.6449 0 46.5016C0 20.8202 20.5956 0 46 0C71.4044 0 92 20.8202 92 46.5016H91.9936Z"
									fill="#D9D9D9" />

								<!-- Apple Logo (scaled & centered) -->
								<g transform="translate(26, 23)">
									<path
										d="M38.7593 36.6273C38.0485 38.2693 37.2071 39.7808 36.2324 41.1705C34.9036 43.0649 33.8157 44.3762 32.9773 45.1044C31.6776 46.2997 30.285 46.9118 28.7938 46.9467C27.7233 46.9467 26.4323 46.642 24.9295 46.0241C23.4218 45.409 22.0362 45.1044 20.7693 45.1044C19.4406 45.1044 18.0155 45.409 16.4913 46.0241C14.9647 46.642 13.7349 46.9641 12.7946 46.996C11.3646 47.0569 9.93931 46.4274 8.51659 45.1044C7.60853 44.3124 6.47274 42.9547 5.1121 41.0312C3.65225 38.9772 2.45204 36.5954 1.51178 33.8799C0.504799 30.9468 0 28.1066 0 25.3569C0 22.2071 0.680608 19.4905 2.04385 17.214C3.11525 15.3854 4.54058 13.9429 6.32449 12.884C8.1084 11.8251 10.0359 11.2855 12.1117 11.2509C13.2475 11.2509 14.7369 11.6023 16.5879 12.2927C18.4336 12.9855 19.6187 13.3369 20.1383 13.3369C20.5267 13.3369 21.8433 12.9261 24.0751 12.1071C26.1857 11.3476 27.967 11.0331 29.4263 11.1569C33.3805 11.4761 36.3513 13.0349 38.327 15.8432C34.7905 17.986 33.0411 20.9872 33.0759 24.8373C33.1078 27.8362 34.1958 30.3318 36.3339 32.3133C37.3029 33.2329 38.385 33.9437 39.589 34.4485C39.3279 35.2057 39.0523 35.931 38.7593 36.6273ZM29.6903 0.940268C29.6903 3.29081 28.8315 5.48549 27.1199 7.51688C25.0543 9.93179 22.5558 11.3272 19.8464 11.107C19.8119 10.8251 19.7919 10.5283 19.7919 10.2164C19.7919 7.95988 20.7742 5.54497 22.5187 3.57045C23.3896 2.57071 24.4972 1.73945 25.8405 1.07633C27.1808 0.423108 28.4486 0.0618618 29.641 0C29.6758 0.31423 29.6903 0.62848 29.6903 0.940237V0.940268Z"
										fill="#525252" />
								</g>
							</svg>
						</q-btn>
						<!-- Label Below -->
						<div class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-base md:tw-text-lg lg:tw-text-xl">
							Apple
						</div>
					</div>
				</div>
			</div>
		</q-card>
		<!-- Loading Overlay -->
		<div v-if="isLoading"
			class="tw-absolute tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[9000] tw-bg-black tw-bg-opacity-70">
			<div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
				<div
					class="tw-animate-spin tw-rounded-full tw-h-20 tw-w-20 tw-border-t-4 tw-border-b-4 tw-border-[#f35610] tw-mb-4">
				</div>
				<p class="tw-text-white tw-font-ExpandedBold tw-text-[20px]">{{ loadingMessage }}</p>
			</div>
		</div>
		<!-- Success Overlay -->
		<div v-if="isSuccess" :class="{
			'tw-absolute tw-inset-0 tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[8000] tw-bg-black tw-bg-opacity-40 tw-overflow-hidden': !isMobileView,
			'tw-absolute tw-inset-0 tw-w-full tw-h-full tw-flex tw-flex-col tw-z-[8000] tw-bg-black tw-bg-opacity-40 tw-overflow-hidden': isMobileView
		}">
			<q-card
				:class="{ 'md:tw-px-12 lg:tw-px-16 tw-py-14 lg:tw-py-14 tw-rounded-xl tw-flex tw-flex-col tw-gap-8 md:tw-max-w-lg lg:tw-max-w-2xl': !isMobileView, 'tw-px-8 tw-py-10 tw-flex tw-flex-col tw-gap-8 tw-w-full tw-h-full tw-justify-between': isMobileView }">
				<div class="tw-flex tw-items-center tw-justify-between">
					<p class="tw-text-2xl tw-text-[#f35610] tw-font-SemiExpandedExtraBold">
						VERIFICATION
					</p>
					<q-btn flat round dense icon="close" v-close-popup />
				</div>

				<div class="tw-items-center tw-text-center">
					<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-2">
						<SuccessSvg class="tw-w-10 tw-h-10" />
						<h3
							class="tw-text-[20px] md:tw-text-[28px] lg:tw-text-[28px] tw-font-ExpandedBold tw-text-[rgba(243,86,16,1)] tw-my-2">
							Verification Link Sent!
						</h3>
					</div>
					<p class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-xl tw-my-3">
						We've sent a verification link to
						<span class="tw-font-SemiExpandedBold">{{ unverifiedEmail }}</span>.
						Please check your email and click the link to verify your account.
					</p>
				</div>

				<div>
					<q-btn label="Got it" type="submit"
						class="full-width tw-rounded-xl tw-text-white tw-text-xl tw-font-SemiExpandedExtraBold"
						@click="handleClose" style="background-color: #f35610; font-style: italic" />
				</div>
			</q-card>
		</div>


		<!-- Error Overlay -->
		<div v-if="isError" :class="{
			'tw-absolute tw-inset-0 tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[8000] tw-bg-black tw-bg-opacity-60 tw-overflow-hidden': !isMobileView,
			'tw-absolute tw-inset-0 tw-w-full tw-h-full tw-flex tw-flex-col tw-z-[8000] tw-bg-white tw-bg-opacity-60 tw-overflow-hidden': $q.screen.lt.sm
		}">
			<q-card
				:class="{ 'tw-px-10 md:tw-px-24 tw-py-20 tw-rounded-xl tw-flex tw-flex-col tw-gap-4 tw-min-w-[50vw]': !$q.screen.lt.sm, 'tw-px-10 md:tw-px-28 tw-py-10 tw-flex tw-flex-col tw-gap-8 tw-w-full tw-h-full tw-justify-between': $q.screen.lt.sm }">

				<div class="tw-flex tw-items-center tw-justify-between">
					<p class="tw-text-2xl tw-text-[#f35610] tw-font-SemiExpandedExtraBold">
						VERIFICATION
					</p>
					<q-btn flat round dense icon="close" @click="handleErrorClose" />
				</div>

				<div class="tw-flex tw-flex-col tw-items-center tw-text-center">
					<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mb-2">
						<ErrorSvg class="tw-w-10 tw-h-10" />
						<h3
							class="tw-text-[20px] md:tw-text-[28px] lg:tw-text-[28px] tw-font-ExpandedBold tw-text-[rgba(243,86,16,1)] tw-my-2">
							{{ errorMessage.includes('Network error') ? 'Network Error' : 'Link Already Sent' }}
						</h3>
					</div>
					<p class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-xl tw-my-3 tw-max-w-lg tw-text-center">
						{{ errorMessage }}
					</p>
				</div>

				<div class="">
					<q-btn label="Okay" type="submit"
						class="full-width tw-rounded-xl tw-text-white tw-text-xl tw-font-SemiExpandedExtraBold"
						@click="handleErrorClose" style="background-color: #f35610; font-style: italic" />
				</div>
			</q-card>
		</div>

		<!-- Social Login Redirect Message Overlay -->
		<div v-if="showSocialLoginMessage && isIOS" :class="{
			'tw-absolute tw-inset-0 tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[8000] tw-bg-black tw-bg-opacity-60 tw-overflow-hidden': !isMobileView,
			'tw-absolute tw-inset-0 tw-w-full tw-h-full tw-flex tw-flex-col tw-z-[8000] tw-bg-white tw-bg-opacity-60 tw-overflow-hidden': $q.screen.lt.sm
		}">
			<q-card
				:class="{ 'tw-px-10 md:tw-px-20 tw-py-16 tw-rounded-xl tw-flex tw-flex-col tw-gap-4 tw-max-w-[40vw]': !$q.screen.lt.sm, 'tw-px-10 md:tw-px-28 tw-py-10 tw-flex tw-flex-col tw-gap-8 tw-w-full tw-h-full tw-justify-between': $q.screen.lt.sm }">
				<div class="tw-flex tw-items-center tw-justify-between">
					<p class="tw-text-2xl tw-text-[#f35610] tw-font-SemiExpandedExtraBold">
						{{ currentSocialLoginName.toUpperCase() }} LOGIN
					</p>
					<q-btn flat round dense icon="close" @click="showSocialLoginMessage = false"
						:disable="isSocialLoginLoading" />
				</div>

				<div class="tw-flex tw-flex-col tw-items-start tw-my-5">
					<p
						class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-base md:tw-text-lg tw-my-2 tw-leading-relaxed">
						To continue signing in with {{ currentSocialLoginName }}, please open this page in the Safari
						browser.
					</p>
					<p
						class="tw-font-ExpandedRegular tw-text-[#666666] tw-text-base md:tw-text-lg tw-my-2 tw-leading-relaxed">
						Tap the button below to proceed.
					</p>
				</div>

				<div class="tw-flex tw-gap-3"
					:class="{ 'tw-flex-row': !$q.screen.lt.sm, 'tw-flex-col': $q.screen.lt.sm }">
					<q-btn label="Cancel" flat :disable="isSocialLoginLoading"
						class="full-width tw-rounded-xl tw-bg-gray-200 tw-text-[#666666] tw-text-lg md:tw-text-xl tw-font-ExpandedRegular"
						@click="showSocialLoginMessage = false" />
					<q-btn :label="isSocialLoginLoading ? 'Redirecting...' : `Continue to ${currentSocialLoginName}`"
						type="submit"
						class="full-width tw-rounded-xl tw-text-white tw-text-lg md:tw-text-xl tw-font-SemiExpandedExtraBold"
						@click="proceedWithSocialLogin" :disable="isSocialLoginLoading"
						style="background-color: #f35610; font-style: italic" />
				</div>
			</q-card>
		</div>

		<!-- Social Login Loading Overlay -->
		<div v-if="isSocialLoginLoading"
			class="tw-absolute tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[9000] tw-bg-black tw-bg-opacity-70">
			<div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
				<div
					class="tw-animate-spin tw-rounded-full tw-h-20 tw-w-20 tw-border-t-4 tw-border-b-4 tw-border-[#f35610] tw-mb-4">
				</div>
				<p class="tw-text-white tw-font-ExpandedBold tw-text-[20px]">Redirecting to {{ currentSocialLoginName
				}}...</p>
			</div>
		</div>
	</q-dialog>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SuccessSvg from './svg/SuccessSvg.vue'
import ErrorSvg from './svg/ErrorSvg.vue'
import { devErrLog } from '../utils/logger'
import logo from '@/assets/6shot-logo.png'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false
	},
	intendedRoute: {
		type: String,
		default: ''
	}
})

const emit = defineEmits(['update:modelValue', 'login-success', 'cancelled'])

const router = useRouter()
const route = useRoute()
const isVisible = ref(props.modelValue)
const email = ref('')
const emailError = ref('')
const isLoading = ref(false)
const isSuccess = ref(false)
const isError = ref(false)
const errorMessage = ref('')
const unverifiedEmail = ref('')
const loadingMessage = ref('Sending Verification Link...')
const referralCode = ref('')
const showSocialLoginMessage = ref(false)
const currentSocialLoginName = ref('Twitter')
const currentSocialLoginAction = ref('')
const isSocialLoginLoading = ref(false)

const isMobileView = ref(false);
const isTabletView = ref(false);
const isIOS = ref(false);

// Detect iOS device
const detectIOS = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	const isIOSDevice = /iphone|ipad|ipod/.test(userAgent) ||
		(/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1); // iPad on iOS 13+
	return isIOSDevice;
};

onMounted(() => {
	// Detect iOS
	isIOS.value = detectIOS();

	const mobileQuery = window.matchMedia("(max-width: 768px)");
	const tabletQuery = window.matchMedia("(min-width: 768px) and (max-width: 1439px)");

	// Set initial values
	isMobileView.value = mobileQuery.matches;
	isTabletView.value = tabletQuery.matches;

	// Handlers
	const updateMobile = (e) => { isMobileView.value = e.matches; };
	const updateTablet = (e) => { isTabletView.value = e.matches; };

	// Add listeners
	mobileQuery.addEventListener("change", updateMobile);
	tabletQuery.addEventListener("change", updateTablet);

	// Cleanup
	onUnmounted(() => {
		mobileQuery.removeEventListener("change", updateMobile);
		tabletQuery.removeEventListener("change", updateTablet);
	});
});

onMounted(() => {
	if (route.query.ref) {
		referralCode.value = route.query.ref
		console.log('Captured referral code from query:', referralCode.value)
	}
	else if (route.params.shareCode) {
		referralCode.value = route.params.shareCode
		console.log('Captured share code from params:', referralCode.value)
	}
})

watch(() => props.modelValue, (newVal) => {
	isVisible.value = newVal
	if (newVal) {
		if (route.query.ref) {
			referralCode.value = route.query.ref
		} else if (route.params.shareCode) {
			referralCode.value = route.params.shareCode
		}
	}
})

const validateEmail = () => {
	email.value = email.value.trim()
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	emailError.value = regex.test(email.value) ? '' : 'Please enter a valid email'
}

const sendLink = async () => {
	validateEmail()

	if (emailError.value) {
		return
	}

	isLoading.value = true
	unverifiedEmail.value = email.value

	try {
		const payload = { email: email.value }

		if (referralCode.value) {
			payload.referral_code = referralCode.value
		}

		const response = await fetch('/users/login', {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-Token': window.csrfToken
			},
			body: JSON.stringify(payload),
		})

		if (response.ok) {
			isLoading.value = false
			isSuccess.value = true
		} else {
			const errorData = await response.json()
			isLoading.value = false
			isError.value = true
			errorMessage.value = errorData.error || 'Failed to send verification link'
		}
	} catch (error) {
		devErrLog('Failed to send link:', error.message)
		isLoading.value = false
		isError.value = true
		errorMessage.value = 'Network error. Please try again.'
	}
}

const closeDialog = () => {
	isVisible.value = false
	emit('cancelled')
	resetForm()
}

watch(isVisible, (newVal, oldVal) => {
	if (oldVal && !newVal) {
		emit('cancelled')
		resetForm()
	}
	emit('update:modelValue', newVal)
})

const handleClose = () => {
	isSuccess.value = false
	isVisible.value = false
	emit('login-success')
	resetForm()

	if (props.intendedRoute) {
		sessionStorage.setItem('redirectAfterLogin', props.intendedRoute)
	}

	router.push('/')
}

const handleErrorClose = () => {
	isError.value = false
	errorMessage.value = ''
}

const resetForm = () => {
	email.value = ''
	emailError.value = ''
	isLoading.value = false
	isSuccess.value = false
	isError.value = false
	errorMessage.value = ''
	unverifiedEmail.value = ''
}

const showSocialLoginModal = (loginName, loginAction) => {
	currentSocialLoginName.value = loginName
	currentSocialLoginAction.value = loginAction

	// Show message only on iOS devices
	if (isIOS.value) {
		showSocialLoginMessage.value = true
	} else {
		proceedWithSocialLogin()
	}
}

const proceedWithSocialLogin = () => {
	// Show loading state
	isSocialLoginLoading.value = true

	// Hide the message modal
	showSocialLoginMessage.value = false

	// Small delay to ensure loading state is visible
	setTimeout(() => {
		// Create and submit the form
		const form = document.createElement('form')
		form.method = 'POST'
		form.action = currentSocialLoginAction.value

		const csrfToken = window.csrfToken || document.querySelector('meta[name="csrf-token"]')?.content
		if (csrfToken) {
			const tokenInput = document.createElement('input')
			tokenInput.type = 'hidden'
			tokenInput.name = 'authenticity_token'
			tokenInput.value = csrfToken
			form.appendChild(tokenInput)
		}

		document.body.appendChild(form)
		form.submit()
	}, 100)
}

const loginTwitter = () => {
	showSocialLoginModal('Twitter', '/users/auth/twitter2')
}

const loginFacebook = () => {
	showSocialLoginModal('Facebook', '/users/auth/facebook')
	//  window.location.href = "/users/auth/instagram";
}

const loginApple = () => {
	showSocialLoginModal('Apple', '/users/auth/apple')
}

</script>